import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import HTMLEditor from '../../../../../../components/HTMLEditor';
import { useAuth } from '../../../../../../hooks/useAuth';
import { useEnv } from '../../../../../../context/env-context';
import { makeRequest } from '../../../../../../utils/makeRequest';
import { getHTMLBody, getHTMLWrapper } from '../../../../../../utils/strings';
import { toast } from 'react-toastify';
import { MOBILE_DEVICE_DIMENSIONS } from '../../../../../../utils/mobileDevices';
import HTMLPreview from '../../../../../../components/HTMLPreview';

function ReferralCampaign({
  referralCampaign,
  setReferralCampaign,
  setReferralList,
  width,
  setTabSpinner,
}) {
  const { apiOriginAggregator } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [referralCampaignName, setReferralCampaignName] = useState(referralCampaign.name);

  const [preview, setPreview] = useState({
    device: 'small_phone',
    width:
      MOBILE_DEVICE_DIMENSIONS.small_phone.viewport_width *
      MOBILE_DEVICE_DIMENSIONS.small_phone.scale,
    height:
      MOBILE_DEVICE_DIMENSIONS.small_phone.viewport_height *
      MOBILE_DEVICE_DIMENSIONS.small_phone.scale,
  });
  const [language, setLanguage] = useState('en');
  const [htmlBody, setHtmBody] = useState({
    en: getHTMLBody(referralCampaign.html.en),
    es: getHTMLBody(referralCampaign.html.es),
  });

  const saveReferralCampaign = async () => {
    setTabSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginAggregator}/referral/save`,
      method: 'POST',
      data: JSON.stringify({
        id: referralCampaign.id || undefined,
        name: referralCampaignName,
        html: { en: getHTMLWrapper(htmlBody.en), es: getHTMLWrapper(htmlBody.es) },
      }),
    };

    try {
      const response = await makeRequest(config);

      if (referralCampaign.id) {
        setReferralList(prevList =>
          prevList.map(x =>
            x.id === referralCampaign.id ? { ...x, name: referralCampaignName } : { ...x },
          ),
        );
      } else {
        setReferralList(prevList => [
          ...prevList,
          { id: response.id, name: referralCampaignName, isDefault: false },
        ]);
      }

      setReferralCampaign(null);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setTabSpinner(false);
    }
  };

  return (
    <div className="d-flex flex-column align-items-start">
      <Button
        className="bo-button-inline-link px-0 fw-bold mb-2"
        onClick={() => setReferralCampaign(null)}
      >
        {'< Back to Referral Campaigns List'}
      </Button>
      <div className="w-100 d-flex justify-content-between align-items-end gap-2 mb-3">
        <div>
          <Form.Label className="mb-1">Name</Form.Label>
          <Form.Control
            className="bo-input bo-w-400"
            type="text"
            value={referralCampaignName}
            onChange={e => setReferralCampaignName(e.target.value)}
          />
        </div>
        <Button className="bo-button bo-w-120" onClick={saveReferralCampaign}>
          Save
        </Button>
      </div>
      <div className="d-flex">
        <HTMLEditor
          width={width}
          preview={preview}
          language={language}
          setLanguage={setLanguage}
          value={htmlBody[language]}
          onEditorChange={newValue => setHtmBody(prev => ({ ...prev, [language]: newValue }))}
          onLoadContent={() => setTabSpinner(false)}
        />
        <HTMLPreview
          value={htmlBody[language]}
          preview={preview}
          setPreview={setPreview}
          type="referrals"
        />
      </div>
    </div>
  );
}

export default ReferralCampaign;
